import React from 'react';

import Button from '../../../components/ui/Button';

const SavedOpportunities = ({ count, onViewSaved }) => {
  if (count === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40">
      <Button
        variant="default"
        size="lg"
        onClick={onViewSaved}
        className="shadow-cta"
        iconName="Bookmark"
        iconPosition="left"
      >
        <span className="flex items-center gap-2">
          Saved
          <span className="px-2 py-0.5 bg-white/20 rounded-full text-xs font-bold">
            {count}
          </span>
        </span>
      </Button>
    </div>
  );
};

export default SavedOpportunities;